function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { TAG_TYPES } from '../../types/TagTypes';
export var cleanBlackListedTags = function cleanBlackListedTags(tags) {
  if (tags === void 0) {
    tags = [];
  }

  return tags.map(function (tag) {
    switch (tag.type) {
      case TAG_TYPES.LINK:
        return getSantitizedLink(tag);

      default:
        return tag;
    }
  });
};

function getSantitizedLink(tag) {
  if (tag === void 0) {
    tag = {};
  }

  return cleanedValue(tag.props && tag.props.rel).includes('stylesheet') ? _objectSpread(_objectSpread({}, tag), {
    props: _objectSpread(_objectSpread({}, tag.props), {}, {
      rel: ''
    })
  }) : tag;
}

function cleanedValue(val) {
  if (val === void 0) {
    val = '';
  }

  return val.toLowerCase().trim();
}